import type { DeliveryStatus } from '../lib/api-noti'

const MAP: Record<DeliveryStatus, { cls: string; label: string }> = {
  sent: { cls: 'ok', label: 'sent' },
  queued: { cls: '', label: 'queued' },
  processing: { cls: 'degraded', label: 'processing' },
  failed: { cls: 'down', label: 'failed' },
  skipped: { cls: 'skipped', label: 'skipped' },
}

export function DeliveryStatusPill({ status }: { status: DeliveryStatus }) {
  const m = MAP[status] ?? { cls: '', label: status }
  return <span className={`pill ${m.cls}`}>{m.label}</span>
}
